import { render, staticRenderFns } from "./tit-wrap-line.vue?vue&type=template&id=4bb08d32&scoped=true&"
import script from "./tit-wrap-line.vue?vue&type=script&lang=js&"
export * from "./tit-wrap-line.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb08d32",
  null
  
)

export default component.exports